import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { change as changeFieldValue, formValueSelector, reduxForm, Field } from 'redux-form';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import { renderTextArea, required } from '../../util/inputs';
import { gerarHashForString } from '../../util/stringUtil';
import { showAlertMsg } from '../../util/messagesUtil';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

class ModalCadastroBloqueioPorPeriodoDisponibilidadeVeiculo extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this)
        this.state = {
            dataInicio: null, dataFim: null
        }
    }


    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({ dataInicio: data, dataFim: null })
        } else {
            this.setState({ data, dataFim: data })
        }
    }

    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }

        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    submit() {
        const bloqueio = {
            hash: gerarHashForString(`${moment(this.state.dataInicio).format('DD/MM/YYYY')}-${moment(this.state.dataFim).format('DD/MM/YYYY')}`),
            dataInicio: this.state.dataInicio,
            dataFim: this.state.dataFim,
            motivo: this.props.motivo
        };

        if (this.props.periodosBloqueados.filter(it => this.props.valiarSePeriodoDeBloqueioTemInterseccao(bloqueio.dataInicio, bloqueio.dataFim, it.dataInicio, it.dataFim)).length > 0) {
            showAlertMsg(`O Período data ${moment(bloqueio.dataInicio).format('DD/MM/YYYY')} à ${moment(bloqueio.dataFim).format('DD/MM/YYYY')} informado se encontra dentro de outro período, ou já foi cadastrado`);
            return;
        }

        this.props.adicionarBloqueio(bloqueio);
        this.fecharModal();         
    }

    fecharModal() {
        $('#modalCadastroBloqueioPorPeriodoDisponibilidadeVeiculo')
            .modal('hide');
        $('#modalCadastroBloqueioPorPeriodoDisponibilidadeVeiculo')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    limparFormulario() {
        this.props.reset('formularioBloquearPeridoDisponibilidadeVeiculo');
        this.setState({ dataInicio: null, dataFim: null, diasSelecionados: [] });
    }

    formulario() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;

        return (
            <>
                <form onSubmit={handleSubmit(this.submit)}>
                    <fieldset className="scheduler-border">
                        <legend className="scheduler-border">Informações básicas</legend>
                        <div className="col-12 col-sm-4 col-md-2 mt-2">
                            <label>Data Início?</label>
                            {this.exibirCalendario(true)}
                        </div>
                        <div className="col-12 col-sm-4 col-md-2 mt-2">
                            <label>Data Fim?</label>
                            {this.exibirCalendario()}
                        </div>
                        <div className="col-12 col-sm-9 col-md-9">
                            <div className="form-row mt-2">
                                <div className="col-12 col-sm-9 col-md-9">
                                    <Field name='motivo' css="form-control col-md-12" component={renderTextArea}
                                        className="form-control" max={50} label="Motivo:" validate={[required]}/>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <div className="modal-footer">
                        <button type="submit"
                            disabled={invalid || submitting || !this.state.dataInicio
                                || !this.state.dataFim}
                            className="btn btn-laranja">Incluir</button>
                    </div>
                </form>
            </>
        );
    }

    render() {
        return (
            <div className="modal fade show" id='modalCadastroBloqueioPorPeriodoDisponibilidadeVeiculo' role='dialog'
                aria-labelledby='modalCadastroBloqueioPorPeriodoDisponibilidadeVeiculo' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Bloquear Período</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.formulario()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        motivo: formValueSelector('formularioBloquearPeridoDisponibilidadeVeiculo')(state, 'motivo'),
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioBloquearPeridoDisponibilidadeVeiculo',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalCadastroBloqueioPorPeriodoDisponibilidadeVeiculo));


